import { Injectable } from '@angular/core';

import { BridgeService } from '../bridge/bridge.service';

@Injectable({
    providedIn: 'root',
})
export class ExpressionsService {
    constructor(private _bridge: BridgeService) {}

    validateExpression(expression: string) {
        return this._bridge.validateExpression({ expression });
    }
}
